import GeoPattern from "geopattern";

let filter = null;

$(document)
  .on("keyup", ".module-filtering #filter", _.debounce(onFilter, 300))
  .on("change", ".module-filtering #filter", _.debounce(onFilter, 300))
  .on("change", ".module-header .selector", onSelect)
  .on("click", ".module-header .selector", onStopPropagation);

document.addEventListener("DOMContentLoaded", function () {
  if ($(".module, .module-item").length > 0) {
    initModulesBackground();

    initDom();
    document.getElementById("filter")?.focus();
  }
});

function initDom() {
  $(".module-item").each(function (_index, item) {
    const name = item.dataset.name;
    item.__name = name;
    item.__filter = name;
  });
}

function onFilter() {
  filter = $("#filter").val();
  if (filter.trim().length == 0) {
    filter = null;
  }
  applyFilters();
}

function onStopPropagation(e) {
  e.stopPropagation();
}
function onSelect() {
  $(this).closest(".module-item").toggleClass("selected");
  toggleSelectedAddButton();
}

function initModulesBackground() {
  $(".module, .module-item").each(function () {
    let $module = $(this);
    let $header = $module.find(".module-header");
    let image = $module.data("image");
    if (image != "" && image !== undefined) {
      $header
        .css("backgroundColor", "#555")
        .css("backgroundSize", "cover")
        .css("backgroundRepeat", "no-repeat")
        .css("backgroundImage", `url(${image})`)
        .css("color", "#FFF");
    } else {
      let pattern = GeoPattern.generate($module.data("name"), { color: "#FFF" });
      $header
        .css("backgroundColor", pattern.color)
        .css("backgroundImage", pattern.toDataUrl())
        .css("color", "#555")
        .css("textShadow", "none");
    }
  });
}

function applyFilters() {
  let regexp = new RegExp(filter, "i");

  $(".module-item").each(function () {
    let filterHidden = filter != null && !regexp.test(this.__filter);

    $(this).toggleClass("hidden-item", filterHidden);
  });
}

function toggleSelectedAddButton() {
  let visible = $(".module-item.selected").length > 0;
  if (visible) {
    $(".batch-add-button").css("visibility", "visible");
  } else {
    $(".batch-add-button").css("visibility", "hidden");
  }

  let module_ids = [];
  $(".module-item.selected").each(function () {
    module_ids.push($(this).data("id"));
  });
  $(".batch-add-button input[name=modules]").val(JSON.stringify(module_ids));
}
